
import React, { useState } from 'react';
import { formatCount } from '../utils/format';
import "../css/PostDetail.css";
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

export default function PostDetail({ item, toggleDetails, hideDelete = false }) {
    const navigate = useNavigate();
    const [currentIndex, setCurrentIndex] = React.useState(0);
    const hasMedia = item.media && item.media.length > 0;
    const currentMedia = hasMedia ? item.media[currentIndex] : null;
    const fallbackPhoto = item.photo || item.media?.[0]?.url;
    const [comments, setComments] = React.useState(item.comments || []);
    const [commentText, setCommentText] = React.useState('');
    const commentsRef = React.useRef(null);
    const [showAllComments, setShowAllComments] = React.useState(false);
    const [captionExpanded, setCaptionExpanded] = React.useState(false);
    const [showAboutModal, setShowAboutModal] = React.useState(false);
    const [hideSignUp, setHideSignUp] = useState(false);

    // Toast Functions
    const notifyA = (msg) => toast.error(msg)
    const notifyB = (msg) => toast.success(msg)

    const handlePostComment = async () => {
        const text = commentText && commentText.trim();
        if (!text) return;
        if (text.length > 128) { notifyA('Comment cannot exceed 128 characters'); return; }
        try {
            const res = await fetch('/comment', {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: 'Bearer ' + localStorage.getItem('jwt')
                },
                body: JSON.stringify({ postId: item._id, text })
            });
            const data = await res.json();
            if (res.ok) {
                setComments(data.comments || []);
                setCommentText('');
                // scroll comments to bottom to show latest
                setTimeout(() => {
                    if (commentsRef.current) commentsRef.current.scrollTop = commentsRef.current.scrollHeight;
                }, 50);
            } else {
                notifyA(data.error || 'Failed to post comment');
            }
        } catch (e) {
            notifyA('Failed to post comment');
        }
    }

    const removePost = (postId)=>{
        if(window.confirm("Do you really want to delete this post ?")){
            fetch(`/deletePost/${postId}`,{
                method:"delete",
                headers:{
                    Authorization: "Bearer " + localStorage.getItem("jwt")
                }
            })
            .then((res)=>res.json())
            .then((result)=>{
                console.log(result);
                toggleDetails();
                navigate("/");
                notifyB(result.message)
            });
        }
    };

    return (
        <div className="showComment" style={{display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center"}}>
            <div className={`container ${showAllComments ? 'comments-full' : ''}`}>
                <div className="postPic" style={{position:'relative'}}>
                    {currentMedia && currentMedia.type === 'image' && (
                        <img src={currentMedia.url} alt="" style={{width:'100%',height:'auto',objectFit:'contain'}} />
                    )}
                    {currentMedia && currentMedia.type === 'video' && (
                        <video 
                            src={currentMedia.url} 
                            style={{width:'100%',height:'auto',objectFit:'contain'}} 
                            muted 
                            controls 
                        />
                    )}
                    {!currentMedia && fallbackPhoto && (
                        <img src={fallbackPhoto} alt="" style={{width:'100%',height:'auto',objectFit:'contain'}} />
                    )}
                    {hasMedia && item.media.length > 1 && (
                      <>
                        <button onClick={()=>setCurrentIndex(i=> (i-1+item.media.length)%item.media.length)} style={{position:'absolute',top:'50%',left:0,transform:'translateY(-50%)',background:'rgba(0,0,0,0.3)',border:'none',color:'#fff',fontSize:'24px',cursor:'pointer'}}>‹</button>
                        <button onClick={()=>setCurrentIndex(i=> (i+1)%item.media.length)} style={{position:'absolute',top:'50%',right:0,transform:'translateY(-50%)',background:'rgba(0,0,0,0.3)',border:'none',color:'#fff',fontSize:'24px',cursor:'pointer'}}>›</button>
                      </>
                    )}
                </div>
                <div className={hideSignUp ? 'details' : 'details signupHide'}>

                    {/* card-header */}
                    <div className="card-header" style={{ borderBottom: "1px solid #00000029" }}>
                        <div className="card-pic">
                            <img
                                src={(item.postedBy && (item.postedBy.Photo || item.postedBy.PhotoUrl)) || "https://cdn-icons-png.flaticon.com/128/1177/1177568.png"}
                                alt={item.postedBy ? item.postedBy.name : 'user'}
                            />
                        </div>
                        <h5 onClick={() => navigate(`/profile/${item.postedBy._id}`)} >{item.postedBy.name}</h5>
                        <span onClick={() => navigate('/profile/home-post-options')} className="material-symbols-outlined">more_vert</span>
                        {!hideDelete && (
                            <div className="deletePost" onClick={()=>{removePost(item._id)}}>
                                <span className="material-symbols-outlined">delete</span>
                            </div>
                        )}
                    </div>

                    {/* About Post (toggleable) */}
                    {item.aboutPost && (
                        <div style={{padding:'8px 0'}}>
                            <span onClick={() => setShowAboutModal(true)} style={{color:'#0084ff',cursor:'pointer',fontWeight:600}}>
                                About Post
                            </span>
                        </div>
                    )}
                    {/* card-content (caption) - moved above comments */}
                    <div className="card-content">
                        <p>{formatCount(item.likes.length)} Likes</p>
                        <p>
                            {(() => {
                                const caption = item.body || '';
                                const limit = 100;
                                if (caption.length <= limit) return caption;
                                return (
                                    <>
                                        {captionExpanded ? caption : `${caption.slice(0, limit)}...`}
                                        <span onClick={() => setCaptionExpanded(s => !s)} style={{ color: '#0084ff', cursor: 'pointer', marginLeft: 6 }}>
                                            {captionExpanded ? 'Read less' : 'Read more'}
                                        </span>
                                    </>
                                )
                            })()}
                        </p>
                            {comments && comments.length > 0 && !showAllComments && (
                            <p className="view-all" onClick={() => { setShowAllComments(true); setTimeout(()=>{ if(commentsRef.current) commentsRef.current.scrollTop = 0 }, 50); }}>
                                View all comments
                            </p>
                        )}
                            {comments && comments.length === 0 && !showAllComments && (
                                <p style={{color:'#666', marginTop:6}}>No comments yet</p>
                            )}
                        {showAllComments && (
                            <p className="view-all back" onClick={() => setShowAllComments(false)}>Back to post</p>
                        )}
                    </div>

                    {/* commentSection */}
                    <div className="comment-section" style={{ borderBottom: "1px solid #00000029" }} ref={commentsRef}>
                        {comments.map((comment) => (
                            <p className="comm" key={comment._id || Math.random()}>
                                <span className="commenter" style={{ fontWeight: "bolder" }}>{comment.postedBy?.name} {" "}</span>
                                <span className="commentText">{comment.comment}</span>
                            </p>
                        ))}
                    </div>

                    {/* add-comment */}
                    <div className="add-comment">
                        <span className="material-symbols-outlined">sentiment_satisfied</span>
                        <input 
                            type="text" 
                            placeholder='Add a comment' 
                            value={commentText}
                            onChange={(e)=>setCommentText(e.target.value.slice(0,128))}
                            onKeyDown={(e)=>{ if(e.key === 'Enter') handlePostComment(); }}
                            maxLength={128}
                        />
                        <button
                            className='comment'
                            onClick={handlePostComment}
                        >
                            Post
                        </button>
                    </div>
                </div>
            </div>
            <div
                className="close-comment"
                onClick={() => {
                    toggleDetails();
                }}
            >
                <span className="material-symbols-outlined material-symbols-outlined-comment">close</span>
            </div>
                {showAboutModal && (
                    <div className="darkBg" onClick={() => setShowAboutModal(false)}>
                        <div className="centered">
                            <div className="modal" style={{width: '90%', maxWidth: 600, color: '#2c3e50'}} onClick={(e) => e.stopPropagation()}>
                                <div className="modalHeader">
                                    <h5 className="heading">About Post</h5>
                                </div>
                                <button className='closeBtn' onClick={() => setShowAboutModal(false)}>&times;</button>
                                <div className='modalContent' style={{maxHeight: '60vh', overflowY: 'auto', textAlign: 'left'}}>
                                    {item.aboutPost}
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            <button id='postDetailToggle' onClick={() => setHideSignUp(!hideSignUp)}>Show/Hide</button>
        </div>
    )
}

